<template>
  <div id="app" ref="app">
    <router-view />
  </div>
</template>

<script>
import { devicePixelRatio } from "../src/utils/devicePixelRatio";
import { xx } from "@/api/index";
export default {
  name: "App",
  // provide() {
  //   //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
  //   return {
  //     reload: this.reload,
  //   };
  // },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
  // mounted() {
  //   const id = localStorage.getItem("REFRESH_TOKEN");
  //   const to = sessionStorage.getItem("token");
  //   if (id == null && to !== null) {
  //     window.location.reload();
  //     // setTimeout(() => {

  //     //   window.location.reload(true);
  //     // }, 1000);
  //   }
  // },
  // async mounted() {
  // },
  // mounted() {
  //   const computed = function () {
  //     // 设计稿宽度：1920
  //     const desW = 1920;
  //     const devW = document.documentElement.clientWidth;

  //     if (devW > 960) {
  //       document.documentElement.style.fontSize = (devW / desW) * 37.5 + "px";
  //       // 这里的75是使用postcss-px2rem插件时，配置的remUnit的参数值
  //     } else {
  //       const desW = 750;
  //       // document.documentElement.style.width = document.documentElement.clientWidth
  //       document.documentElement.style.fontSize = (devW / desW) * 75 + "px";
  //       // document.documentElement.style.fontSize = window.innerWidth / 10 + 'px'
  //       ////console.log(document.documentElement.clientWidth);
  //     }
  //   };
  //   computed();
  //   window.addEventListener("resize", computed, false);
  // },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  border: 0;
}
html {
  overflow-y: scroll;
}

:root {
  overflow-y: auto;
  overflow-x: hidden;
}

:root body {
  position: absolute;
}

html,
body,
#app {
  width: 100vw;
  // white-space: nowrap;
  .el-tooltip__popper {
    max-width: 600px !important;
  }
}
// ::-webkit-scrollbar {
//   /*隐藏滚轮*/
//   display: none;
// }
::v-deep .el-tooltip__popper {
  max-width: 600px !important;
}
@font-face {
  font-family: "Source Han Sans CN"; //声明的字体名称
  src: url("../src/assets/SourceHanSansCN-Regular(3).ttf"); //字体路径
}
@font-face {
  font-family: "Source-KeynoteartHans"; //声明的字体名称
  src: url("../src/assets/演示斜黑体.otf"); //字体路径
}
</style>
